import Vue from 'vue'

class PayoutRepository {
  // POST /payment/outbound/beneficiaries
  createBeneficiary({ ownerType, ownerId }) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries`,
        method: 'post',
        data: { ownerType, ownerId }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /payment/outbound/beneficiaries/{beneficiaryId}
  getBeneficiary(beneficiaryId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}`,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/beneficiaries/{beneficiaryId}/compliance-link
  // @param {boolean} embedded - true for embedded mode, false/undefined for hosted mode
  // @param {string} returnUrl - optional return URL for hosted mode
  createOnboardingLink(beneficiaryId, embedded = false, returnUrl = null) {
    return new Promise((resolve, reject) => {
      const url = embedded
        ? `/api/payment/outbound/beneficiaries/${beneficiaryId}/compliance-link?embedded=true`
        : `/api/payment/outbound/beneficiaries/${beneficiaryId}/compliance-link`

      const data = returnUrl ? { returnUrl } : undefined

      Vue.auth.fetch({
        url,
        method: 'post',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/beneficiaries/{beneficiaryId}/account-update-link
  createAccountUpdateLink(beneficiaryId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/account-update-link`,
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/beneficiaries/{beneficiaryId}/bank-accounts
  // ⚠️ DEPRECATED - Use createAccountUpdateLink instead
  // This route is no longer supported by the backend and will return a 400 error
  addExternalBankAccount(beneficiaryId, { holderName, iban, country, currency }) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/bank-accounts`,
        method: 'post',
        data: { holderName, iban, country, currency }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /payment/outbound/beneficiaries/{beneficiaryId}/bank-accounts
  listExternalBankAccounts(beneficiaryId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/bank-accounts`,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/bank-accounts/{bankAccountId}/deactivate
  deactivateExternalBankAccount(bankAccountId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/bank-accounts/${bankAccountId}/deactivate`,
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/beneficiaries/{beneficiaryId}/payouts
  createPayout(beneficiaryId, { amount, currency, reference, note, externalBankAccountId }) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/payouts`,
        method: 'post',
        data: { amount, currency, reference, note, externalBankAccountId }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /payment/outbound/beneficiaries/{beneficiaryId}/sync
  syncBeneficiary(beneficiaryId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/sync`,
        method: 'post',
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /payment/outbound/beneficiaries/{beneficiaryId}/transactions
  getBeneficiaryTransactions(beneficiaryId, { page = 1, limit = 20 } = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/outbound/beneficiaries/${beneficiaryId}/transactions`,
        method: 'get',
        // `data`, not `params`: auth.fetch drops a `params` key and maps `data` to the query
        // string itself for GET. With `params`, pagination was never sent.
        data: { page, limit }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }
}

export default new PayoutRepository()
